import { createSlice } from '@reduxjs/toolkit';

/**
 * Filter Slice - Manages filter state across dashboard pages
 * 
 * This slice provides centralized filter management for different sections
 * of the dashboard, replacing the FilterContext with Redux state management.
 */

const initialState = {
    filtersBySection: {},
};

export const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        /**
         * Set all filters for a specific section
         */
        setFilters: (state, action) => {
            const { sectionName, filters } = action.payload;
            state.filtersBySection[sectionName] = filters;
        },
        
        /**
         * Update a specific filter for a section
         */
        updateFilter: (state, action) => {
            const { sectionName, filterKey, value } = action.payload;
            if (!state.filtersBySection[sectionName]) {
                state.filtersBySection[sectionName] = {};
            }
            state.filtersBySection[sectionName][filterKey] = value;
        },
        
        /**
         * Clear all filters for a section
         */
        clearFilters: (state, action) => {
            const { sectionName } = action.payload;
            state.filtersBySection[sectionName] = {};
        },
        
        /**
         * Clear all filters for all sections
         */
        clearAllFilters: (state) => {
            state.filtersBySection = {};
        },
    },
});

// Action creators
export const { setFilters, updateFilter, clearFilters, clearAllFilters } =
    filterSlice.actions;

// Selectors
export const selectFiltersBySection = (state) => state.filter.filtersBySection;
export const selectFiltersForSection = (sectionName) => (state) =>
    state.filter.filtersBySection[sectionName] || {};

export default filterSlice.reducer;
